<template>
  <div class="data-examine-box w-full h-full p-4 box-border overflow-hidden">
    <div class="card h-full box-border bg-white shadow-theme rounded">
      <div class="card-body">
        <ul class="border-b border-solid" style="border-color: #e7e9eb">
          <router-link
            v-for="menu in menus"
            tag="li"
            :to="{
              path: menu.path,
              query:{scene: $route.query.scene}
            }"
            :key="menu.meta.id"
            class="cursor-pointer leading-22 text-theme-black-650 text-medium inline-block px-6 py-3"
          >
            {{ menu.meta.label }}
          </router-link>
        </ul>

        <div class="main-box w-full box-border h-full" style="overflow: auto">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataExamine',
  data() {
    return {}
  },
  created() {
    // 此页面再普通问卷 和 我承接的问卷都要使用。所以需要根据当前路由获取同级路由
    // this.menus = this.$dygcRouter.getChildrenByName('data-examine')
    this.menus = (this.$dygcRouter.get(this.$route.meta.parentId)?.children || []).filter(
      menu => !menu.meta?.hidden
    )
  }
}
</script>
<style lang="scss" scoped>
.data-examine-box {
  .router-link-active {
    @apply text-theme border-theme border-b-2 border-solid;
  }
  .card .card-body {
    height: calc(100% - 50px);
  }
}
</style>
